import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-skeleton-left-menu-items',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './skeleton-left-menu-items.component.html',
})
export class SkeletonLeftMenuItemsComponent {
  isIcon = input<boolean>(false);
}
